import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Suspense as _Suspense, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed h-screen w-screen z-50"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "bg-color-background-gray-medium bg-opacity-50 mx-auto h-full w-full" }, null, -1)
const _hoisted_3 = {
  id: "app-container",
  class: "w-screen mx-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorDialog = _resolveComponent("ErrorDialog")!
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_OrderArticleDialog = _resolveComponent("OrderArticleDialog")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_BottomBar = _resolveComponent("BottomBar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.modalOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_ErrorDialog),
          _createVNode(_component_ConfirmationDialog),
          (_ctx.orderArticleDialog.isVisible)
            ? (_openBlock(), _createBlock(_component_OrderArticleDialog, { key: 0 }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createBlock(_Suspense, null, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_component_router_view, {
            key: _ctx.route.fullPath
          }))
        ]),
        _: 1
      })),
      _createVNode(_component_BottomBar)
    ])
  ], 64))
}